export { default as IconSvg24Support } from './24Support';
export { default as IconSvg3DRotate } from './3DRotate';
export { default as IconFire } from './Fire';
export { default as IconStatisticsNumbers } from './StatisticsNumbers';
export { default as IconActivity } from './Activity';
export { default as IconAddSquare } from './AddSquare';
export { default as IconAdd } from './Add';
export { default as IconAdditem } from './Additem';
export { default as IconArchiveAdd } from './ArchiveAdd';
export { default as IconArchiveMinus } from './ArchiveMinus';
export { default as IconArchiveSlash } from './ArchiveSlash';
export { default as IconArchiveTick } from './ArchiveTick';
export { default as IconArchive } from './Archive';
export { default as IconArrow2 } from './Arrow2';
export { default as IconArrow3 } from './Arrow3';
export { default as IconArrowDown1 } from './ArrowDown1';
export { default as IconArrowDown } from './ArrowDown';
export { default as IconArrowLeft1 } from './ArrowLeft1';
export { default as IconArrowLeftCircle } from './ArrowLeftCircle';
export { default as IconArrowLeft } from './ArrowLeft';
export { default as IconArrowRight1 } from './ArrowRight1';
export { default as IconArrowRight2 } from './ArrowRight2';
export { default as IconArrowRight } from './ArrowRight';
export { default as IconArrowSquareDown } from './ArrowSquareDown';
export { default as IconArrowSquareLeft } from './ArrowSquareLeft';
export { default as IconArrowSquareRight } from './ArrowSquareRight';
export { default as IconArrowSquareUp } from './ArrowSquareUp';
export { default as IconArrowSwapHorizontal } from './ArrowSwapHorizontal';
export { default as IconArrowSwap } from './ArrowSwap';
export { default as IconArrowUp1 } from './ArrowUp1';
export { default as IconArrowUp } from './ArrowUp';
export { default as IconAwards } from './Awards';
export { default as IconBag2 } from './Bag2';
export { default as IconBagCross1 } from './BagCross1';
export { default as IconBagCross } from './BagCross';
export { default as IconBagHappy } from './BagHappy';
export { default as IconBagTick2 } from './BagTick2';
export { default as IconBagTick } from './BagTick';
export { default as IconBagTimer } from './BagTimer';
export { default as IconBag } from './Bag';
export { default as IconBarcode } from './Barcode';
export { default as IconBirthday1 } from './Birthday1';
export { default as IconBook } from './Book';
export { default as IconBookmark } from './Bookmark';
export { default as IconBox1 } from './Box1';
export { default as IconBoxAdd } from './BoxAdd';
export { default as IconBoxRemove } from './BoxRemove';
export { default as IconBoxSearch } from './BoxSearch';
export { default as IconBoxTick } from './BoxTick';
export { default as IconBoxTime } from './BoxTime';
export { default as IconBox } from './Box';
export { default as IconBrandValue } from './BrandValue';
export { default as IconBriefcase } from './Briefcase';
export { default as IconBrifecaseCross } from './BrifecaseCross';
export { default as IconBrifecaseTick } from './BrifecaseTick';
export { default as IconBrifecaseTimer } from './BrifecaseTimer';
export { default as IconBrush1 } from './Brush1';
export { default as IconBrush2 } from './Brush2';
export { default as IconBrush } from './Brush';
export { default as IconBucket } from './Bucket';
export { default as IconBus } from './Bus';
export { default as IconCalendarEdit } from './CalendarEdit';
export { default as IconCalendarSearch } from './CalendarSearch';
export { default as IconCalendarTick } from './CalendarTick';
export { default as IconCalendar } from './Calendar';
export { default as IconCallAdd } from './CallAdd';
export { default as IconCallCalling } from './CallCalling';
export { default as IconCallMinus } from './CallMinus';
export { default as IconCallReceived } from './CallReceived';
export { default as IconCallRemove } from './CallRemove';
export { default as IconCallSlash } from './CallSlash';
export { default as IconCall } from './Call';
export { default as IconCameraSlash } from './CameraSlash';
export { default as IconCamera } from './Camera';
export { default as IconCar } from './Car';
export { default as IconCardAdd } from './CardAdd';
export { default as IconCardEdit } from './CardEdit';
export { default as IconCardRemove } from './CardRemove';
export { default as IconCardSlash } from './CardSlash';
export { default as IconCardTick } from './CardTick';
export { default as IconCard } from './Card';
export { default as IconCards } from './Cards';
export { default as IconCategory } from './Category';
export { default as IconCategoryFilled } from './CategoryFilled';
export { default as IconChart1 } from './Chart1';
export { default as IconChart2 } from './Chart2';
export { default as IconChartFail } from './ChartFail';
export { default as IconChartSuccess } from './ChartSuccess';
export { default as IconChart } from './Chart';
export { default as IconClock } from './Clock';
export { default as IconCloseSquare } from './CloseSquare';
export { default as IconClose } from './Close';
export { default as IconCloverOutline1 } from './CloverOutline1';
export { default as IconCompany } from './Company';
export { default as IconConvert3DCube } from './Convert3DCube';
export { default as IconConvertshape2 } from './Convertshape2';
export { default as IconConvertshape } from './Convertshape';
export { default as IconCookie } from './Cookie';
export { default as IconCopySuccess } from './CopySuccess';
export { default as IconCopy } from './Copy';
export { default as IconCrop } from './Crop';
export { default as IconDanger } from './Danger';
export { default as IconDirectInbox } from './DirectInbox';
export { default as IconDirectNormal } from './DirectNormal';
export { default as IconDirectNotification } from './DirectNotification';
export { default as IconDirectSend } from './DirectSend';
export { default as IconDirect } from './Direct';
export { default as IconDirectboxDefault } from './DirectboxDefault';
export { default as IconDislike } from './Dislike';
export { default as IconDocumentFilter } from './DocumentFilter';
export { default as IconDocumentText } from './DocumentText';
export { default as IconDocument } from './Document';
export { default as IconEdit2 } from './Edit2';
export { default as IconEdit } from './Edit';
export { default as IconElement3 } from './Element3';
export { default as IconEmptyWalletChange } from './EmptyWalletChange';
export { default as IconEmptyWallet } from './EmptyWallet';
export { default as IconEraser } from './Eraser';
export { default as IconExport1 } from './Export1';
export { default as IconExport } from './Export';
export { default as IconEyeSlash } from './EyeSlash';
export { default as IconEye } from './Eye';
export { default as IconFilterRemove } from './FilterRemove';
export { default as IconFilterSearch } from './FilterSearch';
export { default as IconFilterSquare } from './FilterSquare';
export { default as IconFilter } from './Filter';
export { default as IconFlag2 } from './Flag2';
export { default as IconFlag } from './Flag';
export { default as IconFlashSlash } from './FlashSlash';
export { default as IconFlash } from './Flash';
export { default as IconFolderFavorite } from './FolderFavorite';
export { default as IconFolder } from './Folder';
export { default as IconFrame1 } from './Frame1';
export { default as IconFrame } from './Frame';
export { default as IconFrameFilled } from './FrameFilled';
export { default as IconFriends } from './Friends';
export { default as IconGallery2 } from './Gallery2';
export { default as IconGalleryAdd } from './GalleryAdd';
export { default as IconGallerySlash } from './GallerySlash';
export { default as IconGallery } from './Gallery';
export { default as IconGift } from './Gift';
export { default as IconGlobalEdit } from './GlobalEdit';
export { default as IconGlobalSearch } from './GlobalSearch';
export { default as IconGpsSlash } from './GpsSlash';
export { default as IconGps } from './Gps';
export { default as IconGrid3 } from './Grid3';
export { default as IconHeartFilled } from './HeartFilled';
export { default as IconHeartSlash } from './HeartSlash';
export { default as IconHeart } from './Heart';
export { default as IconHome1 } from './Home1';
export { default as IconHome1Filled } from './Home1Filled';
export { default as IconHome2 } from './Home2';
export { default as IconHome } from './Home';
export { default as IconImage } from './Image';
export { default as IconImport1 } from './Import1';
export { default as IconImport } from './Import';
export { default as IconInfoCircle } from './InfoCircle';
export { default as IconInstagramNegative } from './InstagramNegative';
export { default as IconLampOn } from './LampOn';
export { default as IconLayer } from './Layer';
export { default as IconLike1 } from './Like1';
export { default as IconLikeDislike } from './LikeDislike';
export { default as IconLikeFilled } from './LikeFilled';
export { default as IconLikeTag } from './LikeTag';
export { default as IconLike } from './Like';
export { default as IconLink1 } from './Link1';
export { default as IconLink } from './Link';
export { default as IconLinkedInNegative } from './LinkedInNegative';
export { default as IconLocationAdd } from './LocationAdd';
export { default as IconLocationCross } from './LocationCross';
export { default as IconLocationMinus } from './LocationMinus';
export { default as IconLocationSlash } from './LocationSlash';
export { default as IconLocationTick } from './LocationTick';
export { default as IconLocation } from './Location';
export { default as IconLock } from './Lock';
export { default as IconLogin } from './Login';
export { default as IconLogout } from './Logout';
export { default as IconMagicpen } from './Magicpen';
export { default as IconMan } from './Man';
export { default as IconMap1 } from './Map1';
export { default as IconMap } from './Map';
export { default as IconMarkerPin01 } from './MarkerPin01';
export { default as IconMarketing } from './Marketing';
export { default as IconMaximize2 } from './Maximize2';
export { default as IconMaximize } from './Maximize';
export { default as IconMedalStar } from './MedalStar';
export { default as IconMenu1 } from './Menu1';
export { default as IconMenu } from './Menu';
export { default as IconMessage2 } from './Message2';
export { default as IconMessageAdd1 } from './MessageAdd1';
export { default as IconMessageAdd } from './MessageAdd';
export { default as IconMessageEdit } from './MessageEdit';
export { default as IconMessageMinus } from './MessageMinus';
export { default as IconMessageNotif } from './MessageNotif';
export { default as IconMessageQuestion } from './MessageQuestion';
export { default as IconMessageRemove } from './MessageRemove';
export { default as IconMessageSearch } from './MessageSearch';
export { default as IconMessageText1 } from './MessageText1';
export { default as IconMessageText } from './MessageText';
export { default as IconMessageTick } from './MessageTick';
export { default as IconMessageTime } from './MessageTime';
export { default as IconMessage } from './Message';
export { default as IconMessages1 } from './Messages1';
export { default as IconMessages2 } from './Messages2';
export { default as IconMessages3 } from './Messages3';
export { default as IconMessages } from './Messages';
export { default as IconMicrophone2 } from './Microphone2';
export { default as IconMicrophoneSlash } from './MicrophoneSlash';
export { default as IconMinusSquare } from './MinusSquare';
export { default as IconMinus } from './Minus';
export { default as IconMirror } from './Mirror';
export { default as IconMoney2 } from './Money2';
export { default as IconMoney3 } from './Money3';
export { default as IconMoney4 } from './Money4';
export { default as IconMoney } from './Money';
export { default as IconMoneys } from './Moneys';
export { default as IconMoreCircle } from './MoreCircle';
export { default as IconMoreVertical } from './MoreVertical';
export { default as IconMore } from './More';
export { default as IconNote2 } from './Note2';
export { default as IconNotification1 } from './Notification1';
export { default as IconNotificationBing } from './NotificationBing';
export { default as IconNotificationFavorite } from './NotificationFavorite';
export { default as IconNotificationStatus } from './NotificationStatus';
export { default as IconNotification } from './Notification';
export { default as IconPaintbucket } from './Paintbucket';
export { default as IconPath2 } from './Path2';
export { default as IconPath } from './Path';
export { default as IconPauseCircle } from './PauseCircle';
export { default as IconPenAdd } from './PenAdd';
export { default as IconPenClose } from './PenClose';
export { default as IconPenRemove } from './PenRemove';
export { default as IconPercentageSquare } from './PercentageSquare';
export { default as IconPinkbox } from './Pinkbox';
export { default as IconPlayCircle } from './PlayCircle';
export { default as IconPlayFill } from './PlayFill';
export { default as IconPlay } from './Play';
export { default as IconProfileTick } from './ProfileTick';
export { default as IconProgressActivity } from './ProgressActivity';
export { default as IconReceipt2 } from './Receipt2';
export { default as IconReceiptAdd } from './ReceiptAdd';
export { default as IconReceiptEdit } from './ReceiptEdit';
export { default as IconReceiptItem } from './ReceiptItem';
export { default as IconReceiptSearch } from './ReceiptSearch';
export { default as IconReceiptText } from './ReceiptText';
export { default as IconReceived } from './Received';
export { default as IconRecordCircle } from './RecordCircle';
export { default as IconRefresh2 } from './Refresh2';
export { default as IconRefresh } from './Refresh';
export { default as IconRepeat } from './Repeat';
export { default as IconRotateLeft } from './RotateLeft';
export { default as IconRotateRight } from './RotateRight';
export { default as IconSave2 } from './Save2';
export { default as IconSaveAdd } from './SaveAdd';
export { default as IconSaveMinus } from './SaveMinus';
export { default as IconScanBarcode } from './ScanBarcode';
export { default as IconScan } from './Scan';
export { default as IconScanner } from './Scanner';
export { default as IconScissor } from './Scissor';
export { default as IconSearchFavorite } from './SearchFavorite';
export { default as IconSearchNormal } from './SearchNormal';
export { default as IconSearchStatus } from './SearchStatus';
export { default as IconSearchZoomIn } from './SearchZoomIn';
export { default as IconSearchZoomOut } from './SearchZoomOut';
export { default as IconSend2 } from './Send2';
export { default as IconSend } from './Send';
export { default as IconSetting2 } from './Setting2';
export { default as IconSetting3 } from './Setting3';
export { default as IconSetting } from './Setting';
export { default as IconShareProduct } from './ShareProduct';
export { default as IconShare } from './Share';
export { default as IconShieldCross } from './ShieldCross';
export { default as IconShieldSlash } from './ShieldSlash';
export { default as IconShieldTick } from './ShieldTick';
export { default as IconShield } from './Shield';
export { default as IconShopAdd } from './ShopAdd';
export { default as IconShopRemove } from './ShopRemove';
export { default as IconShop } from './Shop';
export { default as IconShoppingBag } from './ShoppingBag';
export { default as IconShoppingCart } from './ShoppingCart';
export { default as IconShoppingCartFilled } from './ShoppingCartFilled';
export { default as IconSlash } from './Slash';
export { default as IconSliderVertical } from './SliderVertical';
export { default as IconSmileys } from './Smileys';
export { default as IconSmsEdit } from './SmsEdit';
export { default as IconSmsNotification } from './SmsNotification';
export { default as IconSmsSearch } from './SmsSearch';
export { default as IconSmsTracking } from './SmsTracking';
export { default as IconSms } from './Sms';
export { default as IconSocialResponsibility } from './SocialResponsibility';
export { default as IconSort } from './Sort';
export { default as IconSound } from './Sound';
export { default as IconSquare } from './Square';
export { default as IconStar1 } from './Star1';
export { default as IconStarFilled } from './StarFilled';
export { default as IconStarSlash } from './StarSlash';
export { default as IconStar } from './Star';
export { default as IconStatus } from './Status';
export { default as IconStopCircle } from './StopCircle';
export { default as IconStory } from './Story';
export { default as IconTagCross } from './TagCross';
export { default as IconTagUser } from './TagUser';
export { default as IconTag } from './Tag';
export { default as IconTaskSquare } from './TaskSquare';
export { default as IconTask } from './Task';
export { default as IconTelegramNegative } from './TelegramNegative';
export { default as IconBaleNegative } from './BaleNegative';
export { default as IconTelegram } from './Telegram';
export { default as IconTickCircle } from './TickCircle';
export { default as IconTickSquare } from './TickSquare';
export { default as IconTick } from './Tick';
export { default as IconTicket2 } from './Ticket2';
export { default as IconTicket } from './Ticket';
export { default as IconTimerPause } from './TimerPause';
export { default as IconTimerStart } from './TimerStart';
export { default as IconTimer } from './Timer';
export { default as IconTransactionMinus } from './TransactionMinus';
export { default as IconTrash } from './Trash';
export { default as IconTruckFast } from './TruckFast';
export { default as IconTruckRemove } from './TruckRemove';
export { default as IconTruckTick } from './TruckTick';
export { default as IconTruckTime } from './TruckTime';
export { default as IconTruck } from './Truck';
export { default as IconUnlock } from './Unlock';
export { default as IconUserSquare } from './UserSquare';
export { default as IconUserTag } from './UserTag';
export { default as IconUser } from './User';
export { default as IconVideoCircle } from './VideoCircle';
export { default as IconVideoSquare } from './VideoSquare';
export { default as IconVideo } from './Video';
export { default as IconVolumeCross } from './VolumeCross';
export { default as IconVolumeHigh } from './VolumeHigh';
export { default as IconVolumeLow1 } from './VolumeLow1';
export { default as IconVolumeLow } from './VolumeLow';
export { default as IconVolumeMute } from './VolumeMute';
export { default as IconVolumeSlash } from './VolumeSlash';
export { default as IconVolumeUp } from './VolumeUp';
export { default as IconWallet1 } from './Wallet1';
export { default as IconWallet2 } from './Wallet2';
export { default as IconWallet3 } from './Wallet3';
export { default as IconWalletAdd1 } from './WalletAdd1';
export { default as IconWalletAdd } from './WalletAdd';
export { default as IconWalletCheck } from './WalletCheck';
export { default as IconWalletSearch } from './WalletSearch';
export { default as IconWallet } from './Wallet';
export { default as IconWoman } from './Woman';
export { default as IconMarkerPin1 } from './MarkerPin1';